(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-text"] && !Shopify.designMode) return;
  try {
    
// This file handles section-specific functionality

// Initialize animations for this specific section
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId === '{{ section.id }}') {
    // Re-initialize Splitting
    const title = document.querySelector('#animated-text-{{ section.id }} .content__title');
    if (title && typeof Splitting !== 'undefined') {
      const splitBy = title.getAttribute('data-split-by') || 'chars';
      Splitting({ target: title, by: splitBy });
      
      // Refresh ScrollTrigger
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.refresh();
      }
    }
  }
});

// Execute on DOM content loaded
document.addEventListener('DOMContentLoaded', function() {
  // Initialize Splitting for this section
  const title = document.querySelector('#animated-text-{{ section.id }} .content__title');
  if (title && typeof Splitting !== 'undefined') {
    const splitBy = title.getAttribute('data-split-by') || 'chars';
    Splitting({ target: title, by: splitBy });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-hover"] && !Shopify.designMode) return;
  try {
    
const portfolioItems = document.querySelectorAll('.portfolio-item');
const hoverImage1 = document.getElementById('hover-image-1');
const hoverImage2 = document.getElementById('hover-image-2');
let currentActiveImage = hoverImage1;
let nextActiveImage = hoverImage2;
let activeItem = null;
let isTransitioning = false;

// Function to handle image transitions
function transitionImages(imgSrc, color, item) {
  // If this is the same item that's already active, do nothing
  if (item === activeItem) return;
  
  // If we're already in a transition, wait
  if (isTransitioning) return;
  
  isTransitioning = true;
  activeItem = item;
  
  // Set up the next image
  nextActiveImage.src = imgSrc;
  nextActiveImage.style.filter = 'blur(10px)';
  nextActiveImage.style.transform = 'translate(-50%, -50%) scale(1.05)';
  
  // Start by making the next image visible but blurred
  nextActiveImage.style.opacity = '1';
  
  // After a short delay, transition the next image to clear and normal scale
  setTimeout(() => {
    nextActiveImage.style.filter = 'blur(0px)';
    nextActiveImage.style.transform = 'translate(-50%, -50%) scale(1)';
    
    // Fade out the current image and blur it
    currentActiveImage.style.opacity = '0';
    currentActiveImage.style.filter = 'blur(10px)';
    currentActiveImage.style.transform = 'translate(-50%, -50%) scale(1.05)';
    
    // Update dots
    portfolioItems.forEach(i => {
      i.querySelector('.project-dot').style.opacity = '0';
    });
    item.querySelector('.project-dot').style.opacity = '1';
    item.querySelector('.project-dot').style.backgroundColor = color;
    
    // After transition, swap the references
    setTimeout(() => {
      // Swap the current and next image references
      const temp = currentActiveImage;
      currentActiveImage = nextActiveImage;
      nextActiveImage = temp;
      
      // Reset the inactive image for the next transition
      nextActiveImage.style.opacity = '0';
      
      isTransitioning = false;
    }, 800); // Match the transition duration
  }, 50);
}

// Handle mouse enter on portfolio items
portfolioItems.forEach(item => {
  item.addEventListener('mouseenter', () => {
    const imgSrc = item.getAttribute('data-image');
    const color = item.getAttribute('data-color');
    
    transitionImages(imgSrc, color, item);
  });
});

// Handle mouse leave from the entire section
document.querySelector('.portfolio-hover-section').addEventListener('mouseleave', () => {
  if (isTransitioning) return;
  
  // Fade out all images
  currentActiveImage.style.opacity = '0';
  currentActiveImage.style.filter = 'blur(10px)';
  currentActiveImage.style.transform = 'translate(-50%, -50%) scale(1.05)';
  nextActiveImage.style.opacity = '0';
  
  // Reset the active dots
  portfolioItems.forEach(i => {
    i.querySelector('.project-dot').style.opacity = '0';
  });
  
  activeItem = null;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  // Original shop preview functionality
  const items = document.querySelectorAll('.shop-preview__item');
  const cursor = document.createElement('div');
  cursor.className = 'shop-preview__cursor-title';
  document.body.appendChild(cursor);

  items.forEach((item) => {
    const title = item.getAttribute('data-title');

    item.addEventListener('mouseenter', () => {
      cursor.textContent = title;
      cursor.style.display = 'block';
    });

    item.addEventListener('mousemove', (e) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    });

    item.addEventListener('mouseleave', () => {
      cursor.style.display = 'none';
    });
  });
  
  // Initialize Splitting for the heading
  if (typeof Splitting !== 'undefined') {
    Splitting({ target: '.shop-preview__heading[data-splitting]', by: 'chars' });
  } else {
    console.warn('Splitting.js is not loaded. Make sure it is included in your theme.');
  }
  
  // Initialize animation for the heading
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    // Effect 10 - Blur Fade In
    const heading = document.querySelector('.shop-preview__heading[data-effect10]');
    if (heading) {
      const chars = heading.querySelectorAll('.char');
      if (chars.length > 0) {
        gsap.fromTo(chars,
          { opacity: 0, filter: 'blur(20px)' },
          { 
            opacity: 1, 
            filter: 'blur(0px)',
            stagger: { each: 0.05, from: 'random' },
            ease: 'power1.inOut',
            scrollTrigger: {
              trigger: heading,
              start: 'top bottom',
              end: 'center center',
              toggleActions: 'play none none reset'
            }
          }
        );
      } else {
        console.warn('No characters found. Splitting.js may not have initialized properly.');
      }
    }
  } else {
    console.warn('GSAP and/or ScrollTrigger are not loaded. Make sure they are included in your theme.');
  }
});

  } catch(e) { console.error(e); }
})();
})();
